import { Space, Divider, Title } from '@mantine/core';

import {NavMenu} from "../components/GetNavMenu";
import {Footer} from "../components/GetFooter";
import {HeroHeader} from "../components/headers/GetHeroHeader";
import {SystemMemoryProps} from "../models/SystemMemoryProps";
import {useStyles} from "../models/styles/NotFoundStyle";
import React from "react";
import {RenderPortfolioGrid} from "../components/portfolio/PortfolioGrid";

export function Home({memory}: SystemMemoryProps) {
    const { classes } = useStyles();

    return (
        <>
        <NavMenu memory={memory}></NavMenu>
            <HeroHeader></HeroHeader>
            <Divider size={5}></Divider><br/>
            <center>
                <Space h="md" />
                <Title order={1} className={classes.title}>Recent Projects</Title>

                <RenderPortfolioGrid rows={1} page={1} memory={{memory: memory}} />
            </center>
        <Footer data={[]}></Footer>
        </>
    )
}